import React from 'react';
import { IOembed, IOembedRich, IOembedVideo } from 'types/prismicVideo';
import { Embed } from 'components/embed/Embed';

interface IEmbedContainer {
  embed: IOembed;
  isColumnLayout?: boolean;
}

export const EmbedContainer = ({ embed, isColumnLayout = false }: IEmbedContainer) => {
  if (!embed) {
    return null;
  }

  // We only support rich or video
  const type = embed.type.toLocaleLowerCase();

  if (type !== 'rich' && type !== 'video') {
    return null;
  }

  const oembed = type === 'rich' ? (embed as IOembedRich) : (embed as IOembedVideo);

  return <Embed oembed={oembed} container={!isColumnLayout} />;
};
